<p-table id="prodStockTable" #prodStockTable
         [value]="prodStockList"
         [totalRecords]="totalRecords"
         [loading]="loading"
         [paginator]="paginator"
         [rows]="rows"
         [showCurrentPageReport]="true"
         [rowsPerPageOptions]="[10,20,50,100]"
         currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} строк"
         dataKey="childStockId"
         styleClass="p-datatable p-datatable-gridlines p-datatable-striped"
         [resizableColumns]="true"
         columnResizeMode="fit">

  <ng-template pTemplate="header">
    <tr>
      <th style="width: 3rem">&nbsp;</th>
      <th pResizableColumn pSortableColumn="childCompanyName" style="width: 25%">Компания <p-sortIcon field="childCompanyName"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="childStockName" style="width: 35%">Склад <p-sortIcon field="childStockName"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="localStockValue" style="width: auto">Остаток <p-sortIcon field="localStockValue"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="stockValue" style="width: auto">Общий остаток <p-sortIcon field="stockValue"></p-sortIcon></th>
      <th style="width: 3rem"></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-prod>
    <tr>
      <td>
      </td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  ">{{prod.childCompanyName}}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  ">{{prod.childStockName}}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right" [class.ready]="prod.lsReady" [class.alarm]="prod.lsAlarm">
        {{prod.localStockValue | number:'1.0-2' }}
      </td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right" [class.ready]="prod.gsReady" [class.alarm]="prod.gsAlarm">
        {{prod.stockValue | number:'1.0-2' }}
      </td>
      <td>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="6">Нет данных для загрузки</td>
    </tr>
  </ng-template>
</p-table>
